import Vue from 'vue'
import App from './App.vue'
import router from './router'
import {
	post
} from './http.js'
import store from './store'
import VueWechatTitle from 'vue-wechat-title'
// Vue.prototype.$http = http;
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueAwesomeSwiper from 'vue-awesome-swiper'

// import style (>= Swiper 6.x)
// import 'swiper/swiper-bundle.css'

Vue.use(VueAwesomeSwiper, /* { default options with global component } */)


// import Swiper from "swiper";
// import "swiper/dist/css/swiper.css";
// import "swiper/dist/js/swiper.min";

Vue.use(VueWechatTitle)
Vue.use(ElementUI);
import {
	Button,
	Select,
	Input,
	Icon,
	Card,
	Tabs,
	Breadcrumb,
	Pagination,
	Radio,
	Checkbox,
	Popover,
	Form,
	Message
	
} from 'element-ui';

Vue.use(Button)
Vue.use(Select)
Vue.use(Input)
Vue.use(Icon)
Vue.use(Card)
Vue.use(Tabs)
Vue.use(Breadcrumb)
Vue.use(Pagination)
Vue.use(Radio)
Vue.use(Checkbox)
Vue.use(Popover)
Vue.use(Form)


router.beforeEach((to, from, next) => {

	// console.log(from)
	let AccessToken = localStorage.getItem('AccessToken');
	if (AccessToken) {
		let AccessTokenTime = localStorage.getItem('AccessTokenTime').replace(/-/g, '/');
		console.log(AccessTokenTime)
		let d = new Date(AccessTokenTime)
		let overAccessTokenTime = d.getTime()
		// 当前时间
		let newtime = new Date().getTime()
		
		if (newtime <= overAccessTokenTime) {
			//token没到期
			
			next();

		} else {
			//token过期
			
			let RefreshTokens = localStorage.getItem('RefreshToken');
			let datas = {
				RefreshToken: RefreshTokens,
				Source: 'web'
			};
			post('/V1/Member/Account/GetToken', datas).then(res => {
				
				if (res.data.Code == 0) {
					localStorage.setItem('AccessToken', res.data.Data.Token);
					localStorage.setItem('AccessTokenTime', res.data.Data.OutTime);
					router.push(to.path)
					next()
				} else {
					// 请求失败
					localStorage.removeItem('AccessToken');
					localStorage.removeItem('RefreshToken');
					localStorage.removeItem('username');
					Message({
						message: '登录信息过期，请重新登录',
						type: 'error'
					});
					router.push("/Login")
					next()
				}
			}).catch(()=>{
				localStorage.removeItem('AccessToken');
				localStorage.removeItem('RefreshToken');
				localStorage.removeItem('username');
				Message({
					message: '登录信息过期，请重新登录',
					type: 'error'
				});
				router.push("/Login")
				next()
			})
		}

	} else {
		// console.log('没登录')
		next();
	}

})



Vue.config.productionTip = false
Vue.prototype.$store = store;
new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')

Vue.directive('title', {
  inserted: function (el) {
    document.title = el.dataset.title
  }
})